import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GMap, { Marker } from './components/GMap';
import markerIcon from './markerIcon.svg';
import { googleApiKey } from './configuration';

import './map-location.css';

export default class MapLocation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMapCreated: false,
    };

    this.onMapCreated = this.onMapCreated.bind(this);
  }

  onMapCreated(map) {
    this.setState({
      isMapCreated: true,
    });

    this.map = map;
  }

  renderMarker() {
    if (this.state.isMapCreated) {
      return (
        <Marker
          position={{ lat: this.props.latitude, lng: this.props.longitude }}
          icon={markerIcon}
          map={this.map}
        />
      );
    }
    return null;
  }

  render() {
    return (
      <div className="map-location">
        <GMap
          className="google-map"
          zoom={this.props.zoom}
          maxZoom={this.props.zoom}
          disableDefaultUI
          params={{ v: '3', apiKey: googleApiKey }}
          google={window.google}
          onMapCreated={this.onMapCreated}
        >
          {this.renderMarker()}
        </GMap>
      </div>
    );
  }
}

MapLocation.propTypes = {
  longitude: PropTypes.number.isRequired,
  latitude: PropTypes.number.isRequired,
  zoom: PropTypes.number,
};

MapLocation.defaultProps = {
  zoom: 11,
};
